import { AxiosResponse } from "axios";
import axiosInstance from "./base";

import { AdminMessage as TAdminMessage } from '../shared/types/adminMessage.type'

export class AdminMessage {

    static getUserMessages(userId: string, tz: string): Promise<AxiosResponse<TAdminMessage[]>> {
        return axiosInstance.get(`admin_messages?user=${userId}&date_now=${tz}`)
    }
}